import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("components", ["appInterfaces"])
    },
    methods: {
        __isDuplicateCode(code) {
            const idx = this.appInterfaces.findIndex(interfaceEntry => interfaceEntry.id
                && (interfaceEntry.id !== this.activeInterface) && (code === interfaceEntry.code));

            return idx !== -1;
        },
        __validateCode(code) { // 0 - ok, -1 - not entered, -2 - duplicate
            const codeOk = code && code.trim();
            let valid = 0;

            if (codeOk) {
                if (this.__isDuplicateCode(codeOk)) {
                    valid = -2;
                }
            } else {
                valid = -1;
            }

            return valid;
        },
        __validateName(name) { // 0 - ok, -1 - not entered
            const nameOk = name && name.trim();

            return nameOk ? 0 : -1;
        }
    }
};
